/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuleSetFilterDto
 */
export interface RuleSetFilterDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleSetFilterDto
     */
    states?: Array<RuleSetFilterDtoStatesEnum>;
    /**
     * Set true to exclude default ruleSets; default False
     * @type {boolean}
     * @memberof RuleSetFilterDto
     */
    excludeDefault?: boolean;
}


/**
 * @export
 */
export const RuleSetFilterDtoStatesEnum = {
    Active: 'ACTIVE',
    Edit: 'EDIT',
    Deleted: 'DELETED'
} as const;
export type RuleSetFilterDtoStatesEnum = typeof RuleSetFilterDtoStatesEnum[keyof typeof RuleSetFilterDtoStatesEnum];


/**
 * Check if a given object implements the RuleSetFilterDto interface.
 */
export function instanceOfRuleSetFilterDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RuleSetFilterDtoFromJSON(json: any): RuleSetFilterDto {
    return RuleSetFilterDtoFromJSONTyped(json, false);
}

export function RuleSetFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleSetFilterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'states': !exists(json, 'states') ? undefined : json['states'],
        'excludeDefault': !exists(json, 'excludeDefault') ? undefined : json['excludeDefault'],
    };
}

export function RuleSetFilterDtoToJSON(value?: RuleSetFilterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'states': value.states,
        'excludeDefault': value.excludeDefault,
    };
}

